"use strict";

exports.__esModule = true;
exports.extractContextFields = exports.GalleryProvider = exports.GalleryContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var GalleryContext;
exports.GalleryContext = GalleryContext;

try {
  exports.GalleryContext = GalleryContext = _react["default"].createContext({});
} catch (e) {
  exports.GalleryContext = GalleryContext = null;
}

var GALLERY_CONTEXT_FIELDS = ['watermark'];

var extractContextFields = function extractContextFields(fields) {
  return GALLERY_CONTEXT_FIELDS.reduce(function (obj, field) {
    return obj[field] = fields[field];
  }, {});
};

exports.extractContextFields = extractContextFields;

var GalleryProvider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(GalleryProvider, _React$Component);

  function GalleryProvider(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = extractContextFields(props); // this.value = {
    //   get: GALLERY_CONTEXT_FIELDS.reduce(
    //     (obj, field) => ({ ...obj, [field]: () => this.state[field] }),
    //     {},
    //   ),
    //   set: GALLERY_CONTEXT_FIELDS.reduce(
    //     (obj, field) => ({
    //       ...obj,
    //       [field]: data => this.setState({ [field]: data }),
    //     }),
    //     {},
    //   ),
    // };

    return _this;
  }

  var _proto = GalleryProvider.prototype;

  _proto.render = function render() {
    if (GalleryContext) {
      // const value = { ...this.value, ...this.state };
      return _react["default"].createElement(GalleryContext.Provider, {
        value: this.state
      }, this.props.children);
    } else {
      return this.props.children;
    }
  };

  return GalleryProvider;
}(_react["default"].Component);

exports.GalleryProvider = GalleryProvider;